import { Table, Icon, Select, Button, Tag, message } from 'antd';
import * as actionTypes from './hostReportActionTypes';
import * as hostReportAPI from '../../api/hostReportAPI';
import moment from 'moment';
const FileSaver = require('file-saver');

export const getLiveCounts = () => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_LIVE_COUNTS });
    try {
        const { data } = await hostReportAPI.getHostLiveCounts();
        dispatch({
            type: actionTypes.FETCH_LIVE_COUNTS_SUCCESS,
            payload: {
                ongoing: data?.ongoing || 0,
                upcoming: data?.upcoming || 0,
                tentative: data?.tentative || 0
            }
        });
    } catch (error) {
        console.error("Failed to fetch live counts", error);
        dispatch({ type: actionTypes.FETCH_LIVE_COUNTS_FAILURE, payload: error });
    }
};

export const getHostReportStats = (dateRange) => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_HOST_REPORT_STATS });
    try {
        const { data } = await hostReportAPI.getHostReportStats(dateRange);
        dispatch({
             type: actionTypes.FETCH_HOST_REPORT_STATS_SUCCESS,
             payload: {
                 totalBookings: data?.totalBookings || 0,
                 confirmedBookings: data?.confirmedBookings || 0,
                 pastBookings: data?.pastBookings || 0,
                 cancelledBookings: data?.cancelledBookings || 0,
                 tentativeBookings: data?.tentativeBookings || 0
             }
        });
    } catch(error) {
        console.error("Failed to fetch host stats", error);
        dispatch({ type: actionTypes.FETCH_HOST_REPORT_STATS_FAILURE, payload: error });
    }
};

export const getHostSpaces = () => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_HOST_SPACES });
    try {
        const { data } = await hostReportAPI.getHostSpaces();
        dispatch({
            type: actionTypes.FETCH_HOST_SPACES_SUCCESS,
            payload: data || []
        });
    } catch (error) {
        console.error("Failed to fetch host spaces", error);
        dispatch({ type: actionTypes.FETCH_HOST_SPACES_FAILURE, payload: error });
    }
}

// Fetch ALL bookings for a given date range (client-side filtering handled in tables)
export const getHostReportData = (bookingDateRange) => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_HOST_REPORT_DATA });
    try {
        const response = await hostReportAPI.getHostBookingDetails(
            1, -1, 'bookingDate', 'desc', '', '', [], '', '', 'bookings', bookingDateRange, ''
        );
        const data = extractData(response);
        dispatch({
            type: actionTypes.FETCH_HOST_REPORT_SUCCESS,
            payload: { dataSource: data.map(item => ({ ...item, key: item.bookingId })) }
        });
    } catch (error) {
        console.error("Failed to fetch booking details", error);
        dispatch({ type: actionTypes.FETCH_HOST_REPORT_FAILURE, payload: error });
    }
};

// Fetch ALL blocked-by-host records for a given date range
export const getBlockedReportData = (bookingDateRange) => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_BLOCKED_REPORT_DATA });
    try {
        const response = await hostReportAPI.getHostBookingDetails(
            1, -1, 'bookingDate', 'desc', '', '', [], '', '', 'blocked', bookingDateRange, ''
        );
        const data = extractData(response);
        dispatch({
            type: actionTypes.FETCH_BLOCKED_REPORT_SUCCESS,
            payload: { dataSource: data.map(item => ({ ...item, key: item.bookingId })) }
        });
    } catch (error) {
        console.error("Failed to fetch blocked report", error);
        dispatch({ type: actionTypes.FETCH_BLOCKED_REPORT_FAILURE, payload: error });
    }
};

// Fetch ALL google-calendar records for a given date range
export const getGoogleReportData = (bookingDateRange) => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_GOOGLE_REPORT_DATA });
    try {
        const response = await hostReportAPI.getHostBookingDetails(
            1, -1, 'bookingDate', 'desc', '', '', [], '', '', 'google', bookingDateRange, ''
        );
        const data = extractData(response);
        dispatch({
            type: actionTypes.FETCH_GOOGLE_REPORT_SUCCESS,
            payload: { dataSource: data.map(item => ({ ...item, key: item.bookingId || Math.random().toString(36) })) }
        });
    } catch (error) {
        dispatch({ type: actionTypes.FETCH_GOOGLE_REPORT_FAILURE, payload: error });
    }
};

// Helper to extract array data from API response
const extractData = (response) => {
    if (response && response.data) {
        if (response.data.content && Array.isArray(response.data.content)) {
            return response.data.content;
        } else if (Array.isArray(response.data)) {
            return response.data;
        }
    }
    return [];
};

export const setHostReportTab = (tab) => ({
    type: actionTypes.SET_HOST_REPORT_TAB,
    payload: tab
});

export const resetHostReportState = () => ({
    type: actionTypes.RESET_HOST_REPORT_STATE
});

// Export all data for the selected date range (no table-level filters)
export const exportReport = (bookingDateRange) => async (dispatch) => {
    dispatch({ type: actionTypes.EXPORT_REPORT_REQUEST });
    try {
        const response = await hostReportAPI.downloadHostReport(
            'bookingDate', 'desc', '', '', [], '', '', 'BOOKINGS', bookingDateRange, ''
        );
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
        FileSaver.saveAs(blob, `HostReport_${moment().format('YYYY-MM-DD')}.csv`);
        dispatch({ type: actionTypes.EXPORT_REPORT_SUCCESS });
    } catch (error) {
        console.error("Export failed", error);
        dispatch({ type: actionTypes.EXPORT_REPORT_FAILURE, payload: error });
    }
};
